import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlumpArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.13402 10L12.866 10C13.7606 10 14.3042 9.14243 13.8172 8.48201L7.95124 0.458354C7.50959 -0.152785 6.49041 -0.152785 6.03744 0.458354L0.182779 8.48201C-0.304165 9.14243 0.239401 10 1.13402 10Z" })
});
export default SvgSlumpArrow;
